import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import styled from "@emotion/styled"

import BackgroundImage from "gatsby-background-image"

const Background = styled(BackgroundImage)`
  width: 100vw;
  height: 800px;
  opacity: 0.2;
  z-index: 0;
  top: 0;
  left: 0;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
    height: 600px;
  }
`
const Outer = styled.div`
  grid-column: span 3;
  display: grid;
  grid-template-columns:
    minmax(24px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(24px, auto);
  width: 100%;
  padding: 32px 0;
  height: 100%;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 24px auto 24px;
  }
`
const Inner = styled.div`
  color: ${props => props.textColor};
  padding: 0 0;
  grid-column: 2 / 3;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 32px;
  justify-content: center;
  align-items: center;
  @media (max-width: ${props => props.theme.breakpoints.lg}) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`

/*
 * This component is built using `gatsby-image` to automatically serve optimized
 * images with lazy loading and reduced file sizes. The image is loaded using a
 * `useStaticQuery`, which allows us to load the image from directly within this
 * component, rather than having to pass the image data down from pages.
 *
 * For more information, see the docs:
 * - `gatsby-image`: https://gatsby.dev/gatsby-image
 * - `useStaticQuery`: https://www.gatsbyjs.org/docs/use-static-query/
 */

const Image = props => {
  const data = useStaticQuery(graphql`
    query {
      placeholderImage: file(relativePath: { eq: "pills.png" }) {
        childImageSharp {
          fluid(
            maxWidth: 1920
            traceSVG: {
              background: "transparent"
              color: "#e9edf5"
              turdSize: 1
            }
          ) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
          }
        }
      }
    }
  `)
  return (
    <Background fluid={data.placeholderImage.childImageSharp.fluid}>
      <Outer>
        <Inner data-sal="fade" data-sal-duration="600">
          {props.children}
        </Inner>
      </Outer>
    </Background>
  )
}

export default Image
